import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  getAllDropdowns,
  addDropdownOption,
  removeDropdownOption
} from "../store/actions";

import {
  Box, Typography, Grid, Card, CardHeader,
  CardContent, Divider, TextField, Button,
  Chip, Stack
} from "@mui/material";

// TagEditor (unchanged)
const TagEditor = ({ title, tags, onAdd, onRemove, placeholder }) => {
  const [input, setInput] = useState("");

  return (
    <Card className="panel-card">
      <CardHeader title={title} />
      <Divider />
      <CardContent>
        <Box className="input-row">
          <TextField
            fullWidth
            placeholder={placeholder}
            value={input}
            className="input-field"
            onChange={(e) => setInput(e.target.value)}
          />

          <Button
            variant="contained"
            className="add-btn"
            onClick={() => {
              if (input.trim()) {
                onAdd(input.trim());
                setInput("");
              }
            }}
          >
            Add
          </Button>
        </Box>

        <Stack direction="row" spacing={1} flexWrap="wrap" className="chip-area">
          {tags?.map((opt) => (
            <Chip
              key={opt._id}
              className="tag-chip"
              label={opt.label}
              onDelete={() => onRemove(opt)}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

const DropdownManager = () => {
  const dispatch = useDispatch();

  // ✅ Local component state
  const [dropdowns, setDropdowns] = useState([]);

  // Load all dropdown categories
  const loadDropdowns = () => {
    dispatch(
      getAllDropdowns((result) => {
        setDropdowns(result.data); // ← store data in local state
      })
    );
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  return (
    <Box className="admin-main">
      <Typography variant="h5" gutterBottom>
        Manage All Dropdown Categories
      </Typography>

      <Grid container spacing={2}>
        {dropdowns?.map((cat) => (
          <Grid item xs={12} md={4} key={cat.category}>
            <TagEditor
              title={cat.category.replace(/_/g, " ").toUpperCase()}
              tags={cat.options}
              placeholder={`Add ${cat.category} option`}
              onAdd={(label) =>
                dispatch(
                  addDropdownOption(cat.category, label, () => loadDropdowns())
                )
              }
              onRemove={(item) =>
                dispatch(
                  removeDropdownOption(cat._id, item._id, () => loadDropdowns())
                )
              }

            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DropdownManager;
